import { createAction } from 'redux-actions';
import { getAccountContactRelationsApi } from './api';

const ACTION_NAMESPACE = 'REFERRAL_WELCOME';
export const actionTypes = {
  GET_ACCOUNT_CONTACT_RELATIONS_PENDING: `${ACTION_NAMESPACE}/GET_ACCOUNT_CONTACT_RELATIONS_PENDING`,
  GET_ACCOUNT_CONTACT_RELATIONS_FULFILLED: `${ACTION_NAMESPACE}/GET_ACCOUNT_CONTACT_RELATIONS_FULFILLED`,
  GET_ACCOUNT_CONTACT_RELATIONS_REJECTED: `${ACTION_NAMESPACE}/GET_ACCOUNT_CONTACT_RELATIONS_REJECTED`,
};

const getAccountContactRelationsPending = createAction(
  actionTypes.GET_ACCOUNT_CONTACT_RELATIONS_PENDING,
  (values) => values,
);

const getAccountContactRelationsFulfilled = createAction(
  actionTypes.GET_ACCOUNT_CONTACT_RELATIONS_FULFILLED,
  (values) => values,
);

const getAccountContactRelationsRejected = createAction(
  actionTypes.GET_ACCOUNT_CONTACT_RELATIONS_REJECTED,
  (values) => values,
);

const getAccountContactRelationDetails = (referralCode) => (dispatch) => {
  dispatch(getAccountContactRelationsPending());

  if (referralCode != null) {
    return getAccountContactRelationsApi(referralCode)
      .then((response) => {
        return dispatch(getAccountContactRelationsFulfilled(response));
      })
      .catch((error) => {
        return dispatch(getAccountContactRelationsRejected(error));
      });
  }
};

export default {
  getAccountContactRelationDetails,
};
